import _extends from "@babel/runtime/helpers/extends";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { CloseIcon as LodestarCloseIcon } from "@smartsheet/lodestar-icons";
import { useCombinedThemeMode } from "@smartsheet/sds-theme-internal";
import { CloseIcon as UrsaCloseIcon } from "@smartsheet/ursa-icons";
import React from "react";
import { StyledModalActionSeparator } from "../styled/ActionSeparator";
import { StyledModalActions } from "../styled/Actions";
import { StyledModalHeader } from "../styled/Header";
import { StyledModalTitle } from "../styled/Title";
import { StyledTitleIcon } from "../styled/TitleIcon";
import { StyledTitleText } from "../styled/TitleText";
import { ModalActionButton } from "./ModalActionButton";
export var ModalHeader = function ModalHeader(props) {
  var _props$isHeadingMulti = props.isHeadingMultiline,
    isHeadingMultiline = _props$isHeadingMulti === void 0 ? true : _props$isHeadingMulti,
    title = props.title,
    titleIcon = props.titleIcon,
    titleProps = props.titleProps,
    modalActions = props.modalActions,
    onCloseRequested = props.onCloseRequested,
    className = props.className,
    _props$ariaLabel = props["aria-label"],
    ariaLabel = _props$ariaLabel === void 0 ? "Close" : _props$ariaLabel,
    _props$type = props.type,
    type = _props$type === void 0 ? "default" : _props$type,
    xButtonProps = props.xButtonProps;
  var themeMode = useCombinedThemeMode();

  /**
   * This will be removed in a future release with this ticket:
   * https://git.lab.smartsheet.com/team-ui-engineering/lodestar-core/-/issues/466
   */
  var realAriaLabel = ariaLabel;
  if (props.ariaLabel && ariaLabel === "Close") {
    realAriaLabel = props.ariaLabel;
  }
  if (process.env.NODE_ENV !== "production") {
    if (props.ariaLabel) {
      console.warn("The 'ariaLabel' prop has been deprecated in favor of the standard 'aria-label'. Please use that instead.");
    }
  }
  var getActionButtonIcon = function getActionButtonIcon() {
    switch (themeMode) {
      case "ursa-light":
        return jsx(UrsaCloseIcon, {
          size: 24
        });
      case "lodestar-light":
      default:
        return jsx(LodestarCloseIcon, null);
    }
  };
  return jsx(StyledModalHeader, {
    className: className
  }, jsx(StyledModalTitle, {
    variant: type === "simple" ? "headerLarge" : "headlineMedium",
    type: type,
    renderAs: "div"
  }, titleIcon && jsx(StyledTitleIcon, null, titleIcon), jsx(StyledTitleText, _extends({}, titleProps, {
    type: type,
    isHeadingMultiline: isHeadingMultiline
  }), title)), jsx(StyledModalActions, {
    themeMode: themeMode
  }, modalActions, modalActions && onCloseRequested && jsx(StyledModalActionSeparator, {
    "data-client-id": "modal-action-separator"
  }), onCloseRequested && jsx(ModalActionButton, _extends({
    onClick: onCloseRequested,
    "aria-label": realAriaLabel,
    content: getActionButtonIcon()
  }, xButtonProps))));
};
//# sourceMappingURL=ModalHeader.js.map